// React
import React, { useEffect, useState, useContext } from "react";
// React
// CSS
import styles from "./Lesson.module.css";
// CSS
// Models
import { I_Teacher, I_UserLessonSubject } from "../../Models/interfaces";
// Models
// Services
import { getSubjectOfUserLesson_Service } from "../../Services/Lessons/get/getSubjectOfUserLesson_Service";
// Services
// Contexts
import { UserTokenContext } from "../../Contexts/userToken";
// Contexts
// Modules
import { useLocation, useParams, useNavigate } from "react-router-dom";
import LessonStatus from "./LessonStatus/LessonStatus";
import LessonSubjectShower from "./LessonSubjectShower/LessonSubjectShower";
import { getSubjectTeachers } from "../../Services/Teachers/get/getSubjectTeachers";
import Swal from "sweetalert2";
import TeacherShower from "./TeacherShower/TeacherShower";
import { SetLessonDataContext } from "../../Contexts/SetLessonDataContext";
import { _stringify } from "../../Utils/_stringify";
import { localStorageAvailabilityChecker } from "../../Utils/localStorageAvailabilityChecker";
import { SetAllDataNeededContext } from "../../Contexts/AllDataNeededContext";
import { toast } from "react-toastify";
// Modules

type LessonProps = {
  setIsNeedFullScreen: React.Dispatch<React.SetStateAction<boolean>>;
};

const Lesson: React.FunctionComponent<LessonProps> = ({
  setIsNeedFullScreen,
}) => {
  //   States
  const [lessonSubjects, setLessonSubjects] = useState<I_UserLessonSubject[]>(
    []
  );
  //

  const [selectedSubject, setSelectedSubject] = useState<
    I_UserLessonSubject | undefined | null
  >(undefined);
  //
  const [teachers, setTeachers] = useState<I_Teacher[]>([]);
  //
  const [isSubjectsPending, setIsSubjectsPending] = useState<boolean>(false);
  //
  const [isTeachersPending, setIsTeachersPending] = useState<boolean>(true);
  //   States
  /********************************************* */
  /********************************************* */
  /********************************************* */
  /********************************************* */
  const userToken = useContext(UserTokenContext);
  const { lessonId } = useParams();
  const { state: lessonData } = useLocation();
  const navigate = useNavigate();
  const setLessonData = useContext(SetLessonDataContext);
  const setAllNeededData = useContext(SetAllDataNeededContext);
  /********************************************* */
  /********************************************* */
  /********************************************* */
  /********************************************* */
  // LifeCycles
  useEffect(() => {
    if (!lessonData) {
      navigate("/");
      return;
    }
    if (!setLessonData) return;
    setLessonData((prevState) => ({
      ...prevState,
      lessonId: String(lessonId),
    }));
    setIsNeedFullScreen(true);
    return () => {
      setIsNeedFullScreen(false);
    };
  }, [setIsNeedFullScreen, navigate, lessonData, lessonId, setLessonData]);
  //
  //
  useEffect(() => {
    setTeachers([]);
    setIsTeachersPending(true);
    setTeachers(lessonData.teachers);
    setIsTeachersPending(false);
  }, [userToken]);
  // LifeCycles

  useEffect(() => {
    const lessonIdStr = _stringify(lessonId);
    const lessonDataStr = _stringify(lessonData);

    const isLocalStorageAvailable = localStorageAvailabilityChecker();

    if (isLocalStorageAvailable) {
      localStorage.setItem("lessonId", lessonIdStr);
      localStorage.setItem("lessonData", lessonDataStr);
    }

    setAllNeededData((prevState) => ({
      ...prevState,
      subjectId: String(selectedSubject?.id),
      lessonId: String(lessonId),
      lessonName: String(lessonData.title),
      sectionName: String(selectedSubject?.title),
    }));
    //
  }, [selectedSubject, lessonId, lessonData, setAllNeededData]);

  return (
    <div className={`${styles.lessonContainer} w-full p-4 dark:!text-black`}>
      <div className={`${styles.top} w-full `}>
        <LessonStatus />
      </div>
      <div className={`${styles.bottom} mt-4 bg-white rounded-lg h-full`}>
        <div
          className={`${styles.teacherContainer} flex flex-row items-start justify-between pt-4 px-2 relative h-full`}
        >
          <div className={`${styles.absoluteLine} absolute top-16`}></div>
          <div className={`${styles.provinceTeachers} pb-2 w-full`}>
            <h1 className="w-full text-center">اساتید استانی</h1>
            <TeacherShower
              isGlobalTeacher={true}
              isTeachersPending={isTeachersPending}
              teachers={teachers}
              state={lessonData}
            />
          </div>
          <div
            className={`${styles.globalTeachers} pb-2 flex flex-col items-center justify-start w-full`}
          >
            <h1 className="w-full text-center ">اساتید کشوری</h1>
            <TeacherShower
              isGlobalTeacher={false}
              isTeachersPending={isTeachersPending}
              teachers={teachers}
              state={lessonData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Lesson;
